import { render } from "./CoachDetail.vue?vue&type=template&id=224d89d1&scoped=true"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"

import "./CoachDetail.vue?vue&type=style&index=0&id=224d89d1&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224d89d1"]])

export default __exports__